// SemesterContext.js
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentSemester, setCurrentSemester } from './store/actions/semester';

const SemesterContext = createContext();

export const SemesterProvider = ({ children }) => {
  const dispatch = useDispatch();
  const currentSemester = useSelector((state) => state.semester.currentSemester);
  const loading = useSelector((state) => state.semester.loading);
  const error = useSelector((state) => state.semester.error);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  // Track previous auth state to detect login - defined here
  const wasAuthenticated = useRef(false);

  useEffect(() => {
    // Fetch current semester when user logs in (transition from not authenticated to authenticated)
    // OR when authenticated and we don't have semester data
    const justLoggedIn = isAuthenticated && !wasAuthenticated.current;
    const needsSemester = isAuthenticated && !currentSemester && !loading;

    if (justLoggedIn || needsSemester) {
      //console.log('Fetching current semester...');
      dispatch(fetchCurrentSemester())
        .then(() => {
          //console.log('Current semester fetched successfully');
        })
        .catch((err) => {
          console.error('Failed to fetch current semester:', err);
        });
    }

    // Update the ref for next render
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated, currentSemester, loading, dispatch]);

  return (
    <SemesterContext.Provider value={{
      currentSemester,
      loading,
      error,
      refreshSemester: () => dispatch(fetchCurrentSemester()),
      setSelectedSemester: (semester) => dispatch(setCurrentSemester(semester)) // Add this
    }}>
      {children}
    </SemesterContext.Provider>
  );
};

export const useSemester = () => {
  return useContext(SemesterContext);
};
